import { createContext } from "react";
import type { ListContextType } from "./List.types";

export const ListContext = createContext<ListContextType>({
	itemStyle: "tick",
});
